var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-image-lightbox-carousel',{ref:"lightbox",attrs:{"show":_vm.sliderVisibility,"images":_vm.images},on:{"change":_vm.changeImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }